import auto1Avatar from "../../../../assets/images/archiveAvatarsicons/auto1.webp";
import auto2Avatar from "../../../../assets/images/archiveAvatarsicons/auto2.webp";
import birdAvatar from "../../../../assets/images/archiveAvatarsicons/bird.webp";
import catAvatar from "../../../../assets/images/archiveAvatarsicons/cat.webp";
import chipAvatar from "../../../../assets/images/archiveAvatarsicons/chip.webp";
import cybergAvatar from "../../../../assets/images/archiveAvatarsicons/cyberg.webp";
import dogAvatar from "../../../../assets/images/archiveAvatarsicons/dog.webp";
import duckAvatar from "../../../../assets/images/archiveAvatarsicons/duck.webp";
import duck2Avatar from "../../../../assets/images/archiveAvatarsicons/duck2.webp";
import duck3Avatar from "../../../../assets/images/archiveAvatarsicons/duck3.webp";
import jeepAvatar from "../../../../assets/images/archiveAvatarsicons/jeep.webp";
import mask1Avatar from "../../../../assets/images/archiveAvatarsicons/mask1.webp";
import mask2Avatar from "../../../../assets/images/archiveAvatarsicons/mask2.webp";
import mask3Avatar from "../../../../assets/images/archiveAvatarsicons/mask3.webp";
import pearAvatar from "../../../../assets/images/archiveAvatarsicons/pear.webp";
import person1Avatar from "../../../../assets/images/archiveAvatarsicons/person1.webp";
import person2Avatar from "../../../../assets/images/archiveAvatarsicons/person2.webp";
import person3Avatar from "../../../../assets/images/archiveAvatarsicons/person3.webp";
import person4Avatar from "../../../../assets/images/archiveAvatarsicons/person4.webp";
import person5Avatar from "../../../../assets/images/archiveAvatarsicons/person5.webp";
import person6Avatar from "../../../../assets/images/archiveAvatarsicons/person6.webp";
import person7Avatar from "../../../../assets/images/archiveAvatarsicons/person7.webp";
import person8Avatar from "../../../../assets/images/archiveAvatarsicons/person8.webp";
import person9Avatar from "../../../../assets/images/archiveAvatarsicons/person9.webp";
import person10Avatar from "../../../../assets/images/archiveAvatarsicons/person10.webp";
import person11Avatar from "../../../../assets/images/archiveAvatarsicons/person11.webp";
import person12Avatar from "../../../../assets/images/archiveAvatarsicons/person12.webp";
import person13Avatar from "../../../../assets/images/archiveAvatarsicons/person13.webp";
import photoAvatar from "../../../../assets/images/archiveAvatarsicons/photo.webp";
import rabbitAvatar from "../../../../assets/images/archiveAvatarsicons/rabbit.webp";
import rexAvatar from "../../../../assets/images/archiveAvatarsicons/rex.webp";
import saturnAvatar from "../../../../assets/images/archiveAvatarsicons/saturn.webp";
import strawberryAvatar from "../../../../assets/images/archiveAvatarsicons/strawberry.webp";
import sunAvatar from "../../../../assets/images/archiveAvatarsicons/sun.webp";
import triceraptorsAvatar from "../../../../assets/images/archiveAvatarsicons/triceraptors.webp";
import vanAvatar from "../../../../assets/images/archiveAvatarsicons/van.webp";

export type ArchiveIconAvatar = {
  id: number;
  name: string;
  src: string;
};

export const mockAvatars: ArchiveIconAvatar[] = [
  { id: 1, name: "Pear", src: pearAvatar },
  { id: 2, name: "Person 7", src: person7Avatar },
  { id: 3, name: "Triceraptors", src: triceraptorsAvatar },
  { id: 4, name: "Van", src: vanAvatar },
  { id: 5, name: "Auto 1", src: auto1Avatar },
  { id: 6, name: "Person 4", src: person4Avatar },
  { id: 7, name: "Dog", src: dogAvatar },
  { id: 8, name: "Bird", src: birdAvatar },
  { id: 9, name: "Person 8", src: person8Avatar },
  { id: 10, name: "Person 5", src: person5Avatar },
  { id: 11, name: "Person 13", src: person13Avatar },
  { id: 12, name: "Mask 2", src: mask2Avatar },
  { id: 13, name: "Strawberry", src: strawberryAvatar },
  { id: 14, name: "Cat", src: catAvatar },
  { id: 15, name: "Person 10", src: person10Avatar },
  { id: 16, name: "Chip", src: chipAvatar },
  { id: 17, name: "Rex", src: rexAvatar },
  { id: 18, name: "Rabbit", src: rabbitAvatar },
  { id: 19, name: "Person 3", src: person3Avatar },
  { id: 20, name: "Person 1", src: person1Avatar },
  { id: 21, name: "Person 9", src: person9Avatar },
  { id: 22, name: "Person 2", src: person2Avatar },
  { id: 23, name: "Jeep", src: jeepAvatar },
  { id: 24, name: "Sun", src: sunAvatar },
  { id: 25, name: "Person 12", src: person12Avatar },
  { id: 26, name: "Duck 3", src: duck3Avatar },
  { id: 27, name: "Photo", src: photoAvatar },
  { id: 28, name: "Cyberg", src: cybergAvatar },
  { id: 29, name: "Mask 3", src: mask3Avatar },
  { id: 30, name: "Saturn", src: saturnAvatar },
  { id: 31, name: "Person 11", src: person11Avatar },
  { id: 32, name: "Mask 1", src: mask1Avatar },
  { id: 33, name: "Auto 2", src: auto2Avatar },
  { id: 34, name: "Person 6", src: person6Avatar },
  { id: 35, name: "Duck 2", src: duck2Avatar },
  { id: 36, name: "Duck", src: duckAvatar },
];

export const fetchMockAvatars = async (page = 1, limit = 10): Promise<ArchiveIconAvatar[]> => {
  // Paginación local mientras usamos imágenes de assets.
  const start = (page - 1) * limit;
  return mockAvatars.slice(start, start + limit);
};

type PokemonListItem = {
  name: string;
};

type PokemonListResponse = {
  results: PokemonListItem[];
};

export const fetchAvatars = async (page = 1, limit = 10): Promise<ArchiveIconAvatar[]> => {
  // paginación.
  const offset = (page - 1) * limit;
  const response = await fetch(`https://pokeapi.co/api/v2/pokemon?limit=${limit}&offset=${offset}`);
  const data = await response.json();

  return (data as PokemonListResponse).results.map((pokemon, index) => {
    const id = offset + index + 1;

    return {
      id,
      name: pokemon.name,
      src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`,
    };
  });
};
